__turbopack_context__.v({
  "badgeContainer": "IconCategoryCard-module-scss-module__rpuuva__badgeContainer",
  "iconWrapper": "IconCategoryCard-module-scss-module__rpuuva__iconWrapper",
  "newBadge": "IconCategoryCard-module-scss-module__rpuuva__newBadge",
  "root": "IconCategoryCard-module-scss-module__rpuuva__root",
  "textWeightHeavy": "IconCategoryCard-module-scss-module__rpuuva__textWeightHeavy",
  "title": "IconCategoryCard-module-scss-module__rpuuva__title",
});
